export default __webpack_public_path__ + "6103326787f2b6f585d3f80ef9b83a78.svg";